import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput, FieldSelectIsActive } from 'motion-components';
import { useTranslation } from 'react-i18next';

export function buildWhereFromFilterValues(values): string {
  let where: any = {};
  if (values) {
    if (values.searchText) {
      const likeObj = { $like: '%' + values.searchText + '%' };
      where = {
        ...where,
        $or: [{ name: likeObj }, { typeCode: likeObj }, { notes: likeObj }],
      };
    }
    if (values.statusId) {
      where = { ...where, statusId: Number(values.statusId) };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  return JSON.stringify(where);
}

export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setSubmitting(false);
    onChange(values);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? true,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (όνομα, τύπος)')}
          type="search"
          disable={disable}
        />
        <FieldSelectIsActive as={FormCol} name="isActive" label={t('Ενεργή')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
